import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import ReactApexChart from "react-apexcharts"
import dictionary from "../../config/dictionary"
import config from "../../common/configuration"
//redux
import { useDispatch, useSelector } from "react-redux"
import { initLoadBillCount } from "../../store/actions"
import { useTranslation } from "react-i18next"
const StackedColumnChart = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [periodData, setPeriodData] = useState([{name:'',data:[]}])
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))

  const { ordersCount, currentUser } = useSelector(state => ({
    ordersCount: state.OrdersCount.billsCount,
    currentUser: state.Dashboard.user,
  }))

  useEffect(() => {
    if (currentUser && auth) {
      loadDataChart()
    }
  }, [currentUser, auth])

  useEffect(() => {
    if (ordersCount.length > 0) {
      buildData()
    }
  }, [ordersCount])
  const loadDataChart = () => {
    const request = {
      societyCode: process.env.REACT_APP_STYLE_TEMPLATE,
      supplierCode: currentUser?.supplier?.id,
    }
    dispatch(initLoadBillCount(request))
  }
  const buildData = () => {
    const payData = { name: t("monitor:orderPayed").toUpperCase(), data: [] }
    const pendingData = {
      name: t("monitor:orderPending").toUpperCase(),
      data: [],
    }
    const data = []
    for (let index = 1; index < 13; index++) {
      payData.data.push(0)
      pendingData.data.push(0)
    }
    ordersCount.forEach(e => {
      if (e.statePayCode === dictionary.configApp.type.orderPayed) {
        payData.data[e.month] = e.count
      } else {
        pendingData.data[e.month] = e.count
      }
    })

    data.push(payData)
    data.push(pendingData)
    setPeriodData(data)
  }

  const options = {
    chart: {
      stacked: !0,
      toolbar: {
        show: 1,
      },
      zoom: {
        enabled: !0,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "15%",
        // endingShape: "rounded"
      },
    },
    dataLabels: {
      enabled: !1,
    },
    xaxis: {
      show: true,
      categories:config.form.month,
      labels: {
        show: ordersCount.length>0,
      },
    },
    colors: ["#0068b5", "#e60004", "#34c38f"],
    legend: {
      position: "bottom",
    },
    fill: {
      opacity: 1,
    },
    noData: {  
      text: t("global:loading"),  
      align: 'center',  
      verticalAlign: 'middle',  
      offsetX: 0,  
      offsetY: 0,  
      style: {  
        color: "#000000",  
        fontSize: '20px',  
        fontFamily: "Helvetica"  
      }  
    }
  }
  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={[...periodData]}
        type="bar"
        height="359"
        className="apex-charts"
      />
    </React.Fragment>
  )
}

StackedColumnChart.propTypes = {
  periodData: PropTypes.any,
}
export default StackedColumnChart
